module.exports = __webpack_public_path__ + "img/defaultThumb.20b84a2f.png";